export default __webpack_public_path__ + "static/media/logo-sm.7773a0a1.svg";